module.exports = __webpack_public_path__ + "img/img29.3c0bc101.svg";